import React, {FC} from "react";
import {
    Box,
    Typography,
} from "@mui/material";
import {
    GarageDetailsAdditionalData,
    IGarageList,
} from "../../../interfaces/Interfaces";
import {BackButton} from "../../buttons/BackButton";
import {RoutesPath} from "../../../enums/RoutesPath";
import {GarageDetailsMap} from "./GarageDetailsMap";
import {GarageDetailsInfo} from "./GarageDetailsInfo";
import {GarageReviews} from "./GarageReviews";
import {RenderGaragePhoto} from "../RenderGaragePhoto";

interface Props {
    garage: IGarageList;
    details: GarageDetailsAdditionalData | null;
}

export const GarageDetailsCardDesktop: FC<Props> = ({garage, details}) => {
    return (
        <>
            <Box
                sx={{
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    position: "relative",
                    pb: 2,
                }}
            >
                <Box sx={{position: "absolute", left: 0}}>
                    <BackButton fallbackUrl={RoutesPath.MOTO_GARAGES}/>
                </Box>
                <Typography variant="h5" component="h2">
                    {garage?.name}
                </Typography>
            </Box>
            <Box
                sx={{
                    display: "flex",
                    gap: 3,
                    flexWrap: "wrap",
                    justifyContent: "flex-start",
                    mb: 3,
                }}
            >
                <Box sx={{flex: 1, minWidth: 400, maxWidth: 600}}>
                    <GarageDetailsMap
                        latitude={garage.latitude}
                        longitude={garage.longitude}
                        height={400}
                        width="100%"
                    />
                </Box>
                <Box
                    sx={{
                        flex: 1,
                        minWidth: 300,
                        maxWidth: 400,
                        display: "flex",
                        flexDirection: "column",
                        alignItems: "center",
                        gap: 2,
                        justifyContent: "flex-start",
                    }}
                >
                    {garage.placePhoto && (
                        <RenderGaragePhoto value={garage.placePhoto} size={250} width={400} height={250}/>
                    )}
                    <Box sx={{width: "100%"}}>
                        <GarageDetailsInfo garage={garage} details={details}/>
                    </Box>
                </Box>
            </Box>
            {details?.reviews && (
                <Box mt={4}>
                    <GarageReviews reviews={details.reviews}/>
                </Box>
            )}
        </>
    );
};
